<h1 mat-dialog-title *ngIf = "product['value'] !== 'skip' && product['value'] !== 'confirm sale recurring product delete'">{{title}}</h1>
<div mat-dialog-content class= "overflow-hide" *ngIf = "product['value'] === 'skip'" >
    <!-- <p>
        <mat-form-field>
            <input matInput [matDatepicker]="dp1" placeholder="Start Date" autocomplete="off" [(ngModel)]="start_date" [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
        </mat-form-field>
    </p>
    
    <p>
        <mat-form-field>
            <input matInput [matDatepicker]="dp2" placeholder="End Date" autocomplete="off"  [(ngModel)]="end_date" [min] = "minDayAfterNextDate">
            <mat-datepicker-toggle matSuffix [for]="dp2" ></mat-datepicker-toggle>
            <mat-datepicker #dp2></mat-datepicker>
        </mat-form-field>
    </p> -->
    <div fxLayout = "column" >
        <div fxLayout = "row" class = "blk-clr">
            <div fxFlex= "80%"><h4>{{product['product']['description']}}</h4></div>
            <div fxFlex= "20%"fxLayoutAlign ="end" class ="cursor"><mat-icon (click) = "close()">clear</mat-icon></div>
        </div>
        <div fxLayout = "row" class = "ft-12 blk-clr" >
            <div fxFlex= "80%">Frequency: {{product['product']['frequency']}}</div>
            <div fxFlex= "20%" fxLayoutAlign ="end">Qty: {{product['product']['quantity']}}</div>
        </div>
    </div>
    <table mat-table  [dataSource]="dataSource" >

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
      
        <!-- date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell  *matHeaderCellDef class ="pd-r-5 pd-l-19"> Delivery Date </th>
            <td mat-cell  *matCellDef="let element"> {{element['delivery_date'] |  storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}</td>
        </ng-container>
      
        <!-- checkAvailability Column -->
        <ng-container matColumnDef="checkAvailability">
          <th mat-header-cell  *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element"> 
                <span class = "warn" *ngIf = "element['skip_delivery'] === 1"><mat-icon >clear</mat-icon></span>
                <span class = "green" *ngIf = "element['unskip_delivery'] === 1"><mat-icon >done</mat-icon></span> 
            </td>
        </ng-container>
      
        <!-- action Column -->
        <ng-container matColumnDef="action" >
            <th mat-header-cell *matHeaderCellDef class = "action pd-l-5 pd-r-19"> Action </th>
            <td mat-cell *matCellDef="let element" class = "action" > 
              <span *ngIf = "element['order'] === 1">Order Generated</span>
               
              <span *ngIf = "element['skip_delivery'] === 1"> <div class="button-container"  >
                    <div class="spinner-container" *ngIf="element['load']">
                    <mat-spinner diameter="24"></mat-spinner>
                    </div>
                    <button mat-button (click) = "unSkipRecurring(element)" [disabled]="element['load']">UnSkip</button>
                    
                </div></span>
              <span *ngIf = "element['unskip_delivery'] === 1">
                    <div class="button-container"  >
                            <div class="spinner-container" *ngIf="element['load']">
                            <mat-spinner diameter="24"></mat-spinner>
                            </div>
                            <button mat-button (click)="cartRecurringSkip(element)" [disabled]="element['load']"> Skip</button>
                        </div>
                  </span>
                </td>
        </ng-container>
      
      
        <tr mat-header-row  *matHeaderRowDef="displayedColumns" class ="bgk-grey"></tr>
        <tr mat-row  *matRowDef="let row; columns: displayedColumns; let i = index; let even = even;"  [ngClass]="{gray: even}"></tr>
    </table>
    <mat-card *ngIf="isLoading" class= "overflow-hide" style="display: flex; justify-content: center; align-items: center">
        <mat-progress-spinner [diameter]="70"
            color="primary" 
            mode="indeterminate">
        </mat-progress-spinner>
    </mat-card>
    <div fxLayoutAlign ="center" class = "pd-top" *ngIf="!isLoading">
        <button mat-button (click) = "getSingleRecurring(25)">Show More Dates</button>
    </div>
</div>
<!-- <div mat-dialog-actions fxLayoutAlign ="end"
    *ngIf =  "product['value'] === 'skip'" class="pb-24px">
    <button  mat-button (click)="saveDates()">Save</button>
    <button mat-button mat-dialog-close="close" >Cancel</button>
</div>  -->
<div mat-dialog-content *ngIf =  "product['value'] === 'stop'">
    <span *ngIf="product['product']['isLastProduct'] ; else matContent">
        Deleting this product will cancel your order for
        {{selectedDeliveryCalendar['delivery_date'] |  storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}.
        Are you sure you want to proceed?
    </span>
    <ng-template #matContent>
        <span>Are you sure you want to stop the delivery of this recurring product?</span>          
    </ng-template>
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'stop'" fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="deleteButtonOptions"mat-button (click)="deleteRecurring()" color = "warn">
        {{product['product']['isLastProduct'] && product['product']['isSaleOrder'] ? 'Yes' : 'Delete'}}
    </mat-spinner-button>
    <button mat-button mat-dialog-close="close" color = "primary">
        {{product['product']['isLastProduct'] && product['product']['isSaleOrder'] ? 'No' : 'Cancel'}}
    </button>
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'cart recurring skip'">
    <span *ngIf="product['product']['isLastProduct']; else matContent">
        Deleting this product will cancel your order for
        {{selectedDeliveryCalendar['delivery_date'] |  storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}.
        Are you sure you want to proceed?
    </span>
    <ng-template #matContent>
        <span>Are you sure you want to delete this product?</span>
    </ng-template>
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'cart recurring skip'" 
    fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="skipButtonOptions" mat-button (click)="cartRecurringSkip()" color = "warn">
        {{ product['product']['isLastProduct']  ? 'Yes' : 'Delete' }}
    </mat-spinner-button>
    <button mat-button mat-dialog-close="close" color = "primary">
        {{ product['product']['isLastProduct'] && product['product']['isUndeliveredOrder'] ? 'No' : 'Cancel' }}
    </button>
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'recurring quantity update'">
    Are you sure you want to update quantity?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'recurring quantity update'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <button mat-button class = "pd-10" (click)="recurringQuantityUpdate()" color = "warn">Yes</button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'recurring frequency update'">
    <p>This recurring start date is used to start date of the product</p>
    <p class="mt-1">
        <mat-form-field>
            <input matInput [matDatepicker]="dp" [matDatepickerFilter]="deliveryDayFilter"  
                placeholder="Recurring Start Date" autocomplete="off" 
                [(ngModel)]="start_date" [min] = "minRecurringStartDate">
            <mat-datepicker-toggle matSuffix [for]="dp" ></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
    </p>
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'recurring frequency update'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="yesButtonOptions" mat-button class = "pd-10" (click)="recurringFrequencyUpdate()" color = "warn">Yes</mat-spinner-button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'cancel saleorder'">
    Are you sure you want to cancel the sale order?
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'skip saleorder'">
    Are you sure you want to skip the sale order for {{product['week']}}?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'cancel saleorder' || product['value'] === 'skip saleorder'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <button  mat-button class = "pd-10" (click)="cancelSaleOrder()" color = "warn">Yes</button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>
<div mat-dialog-content *ngIf =  "product['value'] === 'confirm sale recurring delete'">
    This product has been added to one or more undelivered orders. Stoping this item will remove them for all undelivered orders.
    <span *ngIf="product['product']['isLastProduct'] && product['product']['isSaleOrder']">
        Deleting this product will cancel your order for {{selectedDeliveryCalendar['delivery_date'] |  storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}.
    </span> Are you sure you want to proceed?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'confirm sale recurring delete'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="yesButtonOptions" mat-button class = "pd-10" (click)="deleteSaleRecurringProduct()" color = "warn">Yes</mat-spinner-button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>
<h1 mat-dialog-title class="cardTitle" *ngIf="product['value'] === 'confirm sale recurring product delete'">
    {{title}}    
    <button mat-mini-fab mat-dialog-close="close" color="primary" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>    
</h1>
<div mat-dialog-content *ngIf="product['value'] === 'confirm sale recurring product delete'">
    You have an open order for this product. Are you sure you want to stop the delivery for this recurring product?    
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'confirm sale recurring product delete'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <button mat-raised-button class="pd-10" (click)="deleteRecurring(true)" color="primary">Yes, Stop all</button>
    <button mat-raised-button class="pd-10" (click)="deleteRecurring(false)">Yes, but keep open orders</button>
</div>
<!-- Cancel Scheduled Order Confirmation -->
<div mat-dialog-content *ngIf =  "product['value'] === 'cancel scheduled order'">
   Are you sure you want to cancel the Scheduled Order ?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'cancel scheduled order'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="yesButtonOptions" mat-button class = "pd-10" (click)="deleteScheduledOrder()" color = "warn">Yes</mat-spinner-button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>

<!-- Add Vacation Dates -->
<form [formGroup] = "vacationForm" >

<div mat-dialog-content *ngIf =  "product['value'] === 'add vacation dates' || product['value'] === 'edit vacation dates'">
   <p> Are you traveling and you don't want us to deliver during that time? Please save such events here and your orders won't be generated during that period. It is possible to edit or delete your vacation anytime.</p>
        <!-- <mat-form-field appearance="fill">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker" >
            <input matStartDate placeholder="Start date" formControlName = vacationStartDate>
            <input matEndDate placeholder="End date" formControlName = vacationEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field> -->
        <br>
        <p>
            <mat-form-field>
                <input matInput [matDatepicker]="dp1" placeholder="Start Date" autocomplete="off" formControlName="start_date" [min]="minDate">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
                <mat-error *ngIf = "vacationForm.get('start_date').hasError('required')">Start Date is required</mat-error>
            </mat-form-field>
        </p>
        
        <p>
            <mat-form-field>
                <input matInput [errorStateMatcher]="matcher" [matDatepicker]="dp2" placeholder="End Date" autocomplete="off" formControlName="end_date" [min] = "minDate">
                <mat-datepicker-toggle matSuffix [for]="dp2" ></mat-datepicker-toggle>
                <mat-datepicker #dp2></mat-datepicker>
                <mat-error *ngIf = "vacationForm.get('end_date').hasError('required')">End Date is required</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field >
                <mat-label>Comments (optional)</mat-label>
                <input matInput  formControlName="comments">
            </mat-form-field>
        </p>
    </div>
 <div mat-dialog-actions *ngIf =  "product['value'] === 'add vacation dates' || product['value'] === 'edit vacation dates'" 
     fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
     <mat-spinner-button *ngIf  = "product['value'] === 'add vacation dates'" type = "submit" [options]="yesButtonOptions" mat-button class = "pd-10" (click)="saveVacationDates()" color = "warn">Yes</mat-spinner-button>
     <mat-spinner-button *ngIf  = "product['value'] === 'edit vacation dates'" type = "submit" [options]="yesButtonOptions" mat-button class = "pd-10" (click)="editVactionDates()" color = "warn">Yes</mat-spinner-button>     
     <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
 </div>
</form>

<!-- end -->
<!-- Delete Vacation Dates -->

 <div mat-dialog-content *ngIf =  "product['value'] === 'delete vacation dates'">
    Are you sure you want to delete this vacation?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'delete vacation dates'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <mat-spinner-button [options]="yesButtonOptions" mat-button class = "pd-10" (click)="cancelVacationDates()" color = "warn">Yes</mat-spinner-button>
    <button mat-button class = "pd-10" mat-dialog-close="close" color = "primary">No</button>
</div>
<!-- end -->

<!--  -->
<div mat-dialog-content *ngIf =  "product['value'] === 'update saleorder'">
    Are you sure you want to update the sale order?
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'update saleorder'" 
    fxLayout = "row" fxLayoutAlign ="end" class="pb-24px">
    <button  mat-button class = "pd-10" (click)="updateSaleOrder()" color = "warn">Yes</button>
    <button mat-button class = "pd-10" (click)="closeSaleOrder()" color = "primary">No</button>
</div>

<!-- vacation dates warning -->
<div mat-dialog-content *ngIf =  "product['value'] === 'vacation dates warning'">
    You can’t select a start date that overlaps with your vacation dates. Please choose a different date.
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'vacation dates warning'" 
    fxLayout = "row nowrap" fxLayoutAlign ="end" class="pb-24px">
    <button  mat-raised-button class="pd-10" mat-dialog-close="close">Okay</button>
    <button mat-button class="pd-10" (click)="navigateToVacationDates()" color="warn">View Vacation dates</button>    
</div>
<!-- End -->

<!-- vacation dates warning -->
<div mat-dialog-content *ngIf =  "product['value'] === 'open order warning'">
    Are you sure you want to change the delivery date for this product? Changing the date will remove this product from the order scheduled for <strong>{{ product['deliveryDate'] }}</strong>.
</div>
<div mat-dialog-actions *ngIf =  "product['value'] === 'open order warning'" 
    fxLayout = "row nowrap" fxLayoutAlign ="end" class="pb-24px">
    <button  mat-raised-button class="pd-10" (click)="deleteRecerringItem()">Okay</button>
    <button mat-button class="pd-10" color="warn" mat-dialog-close="close">No</button>    
</div>
<!-- End -->

<!-- Update quantity recurring products -->
<div mat-dialog-content *ngIf="product['value'] === 'confirm sale recurring product quantity'">    
    Changing the quantity will also affect the open orders. Are you sure you want to proceed?
</div>
<div mat-dialog-actions *ngIf="product['value'] === 'confirm sale recurring product quantity'" fxLayoutAlign ="end" class="pb-24px">
    <button  mat-raised-button class="pd-10" (click)="updateQtyRecurringItem()">Yes</button>
    <button mat-button mat-dialog-close="close" color = "primary">Cancel</button>
</div>
<!-- End -->

